import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.8267 6.48469C15.8267 6.05394 16.1828 5.70474 16.6222 5.70474L32.4815 5.70474C32.9209 5.70474 33.277 6.05394 33.277 6.48469C33.277 6.91544 32.9209 7.26463 32.4815 7.26463L17.4176 7.26463V16.9652H8.26989V31.7354C8.26989 32.1661 7.91376 32.5153 7.47444 32.5153C7.03512 32.5153 6.67899 32.1661 6.67899 31.7354V16.1852C6.67899 15.7545 7.03512 15.4053 7.47444 15.4053H15.8267V6.48469Z",
      fill: "#77BD1F"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.1477 11.6518V4.14485C12.1477 2.96028 13.1271 2 14.3352 2H35.8125C37.0206 2 38 2.96028 38 4.14485V25.2033C38 26.3879 37.0206 27.3482 35.8125 27.3482H28.8523V34.8552C28.8523 36.0397 27.8729 37 26.6648 37H5.1875C3.97938 37 3 36.0397 3 34.8552V13.7967C3 12.6121 3.97938 11.6518 5.1875 11.6518H12.1477ZM14.3352 3.55989H35.8125C36.142 3.55989 36.4091 3.82178 36.4091 4.14485V25.2033C36.4091 25.5264 36.142 25.7883 35.8125 25.7883H27.2614V34.8552C27.2614 35.1782 26.9943 35.4401 26.6648 35.4401H5.1875C4.85801 35.4401 4.59091 35.1782 4.59091 34.8552V13.7967C4.59091 13.4736 4.85801 13.2117 5.1875 13.2117H13.7386V4.14485C13.7386 3.82178 14.0057 3.55989 14.3352 3.55989Z",
      fill: "#77BD1F"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.196 10.9694H28.6534V18.3788H22.6875V19.9387H29.3494C29.8437 19.9387 30.2443 19.5459 30.2443 19.0613V10.2869C30.2443 9.80233 29.8437 9.40948 29.3494 9.40948H20.5C20.0058 9.40948 19.6051 9.80233 19.6051 10.2869V28.0307H12.1477V20.6212H18.1136V19.0613H11.4517C10.9575 19.0613 10.5568 19.4541 10.5568 19.9387V28.7131C10.5568 29.1977 10.9575 29.5905 11.4517 29.5905H20.3011C20.7954 29.5905 21.196 29.1977 21.196 28.7131V10.9694Z",
      fill: "#EDB101"
    }, null, -1)
  ]))]))
}
export default { render: render }